import TitleDetail from "../../../components/atoms/TitleDetail";
import SubscriptionStatusComponent from "./SubscriptionStatusComponent";
import InputGroup from "../../../components/atoms/InputGroup";
import React from "react";
import {ClientDetailUseContext} from "../ClientDetailContext";

const UserSubscriptionDetail = () => {
    const {subscriptionInfo}= ClientDetailUseContext();
    console.log("SUBSCRIPTION INFOOOOO : ",subscriptionInfo)
    const {
        boughtDays,
        passedDays,
        boughtGuests,
        loginGuests,
        boughtSms,
        usedSms,
        hasReservePlan,
        reservePlanDetails,
        isFirstPlan,
        hasSubscription,
        subscriptionUntil
    } = subscriptionInfo.details;

    const daysText = `${passedDays} روز از ${boughtDays} روز مصرف شده`;
    const guestsText = `${loginGuests} مهمان از ${boughtGuests} مهمان مصرف شده`;
    const smsText = `${usedSms} پیامک از ${boughtSms} پیامک مصرف شده`;

    // متن وضعیت اشتراک
    const subscriptionStatusText = hasSubscription
        ? `کاربر اشتراک فعال دارد، معتبر تا تاریخ ${subscriptionUntil}`
        : "کاربر اشتراک ندارد";

    // متن اشتراک رزرو
    let reservePlanText = "کاربر اشتراک رزرو ندارد.";
    if (hasReservePlan) {
        const { countMonth, countSms, countGuest } = reservePlanDetails;
        reservePlanText = `کاربر اشتراک رزرو دارد (${countMonth} ماهه، ${countSms} پیامک، ${countGuest} مهمان)`;
    }

    return (
        <div className={"mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px"}>

            {/* عنوان بخش اطلاعات اشتراک */}
            <TitleDetail title={"اطلاعات اشتراک"} />

            {/* وضعیت اشتراک کاربر */}
            <div className="flex flex-row justify-between w-full gap-5 mt-25">
                <SubscriptionStatusComponent
                    iconName={"star"}
                    value={subscriptionStatusText}
                />
            </div>

            {/* اطلاعات مدت زمان اعتبار، مهمان‌ها و پیامک‌ها */}
            <div className="flex flex-row justify-between w-full gap-5 mt-25">
                <InputGroup
                    iconName={"timer"}
                    label="مدت زمان اعتبار"
                    value={daysText}
                    readOnly={true}
                />
                <InputGroup
                    iconName={"profile-2user-dark"}
                    label="وضعیت مهمان"
                    value={guestsText}
                    readOnly={true}
                />
                <InputGroup
                    iconName={"sms-tracking"}
                    label="وضعیت پیامک"
                    value={smsText}
                    readOnly={true}
                />
            </div>

            {/* اطلاعات اشتراک رزرو و اشتراک اولیه */}
            <div className="flex flex-row justify-between w-full gap-5 mt-25">
                <InputGroup
                    iconName={"bubble"}
                    label="اشتراک رزرو دارد؟"
                    value={reservePlanText}
                    readOnly={true}
                />
                <InputGroup
                    iconName={"bubble"}
                    label="اشتراک اولیه دارد؟"
                    value={isFirstPlan ? "بله" : "خیر"}
                    readOnly={true}
                />
            </div>

        </div>
    );
};

export default UserSubscriptionDetail;